// Module
var code = "<md-button class=\"md-icon-button md-primary show-button margin-0 padding-0\" ng-click=\"$ctrl.onShowPanel($event)\"> <bringoz-icon icon-name=\"settings-outline\" class-size=\"lg\"></bringoz-icon> <md-tooltip>{{'View Settings' | translate}}</md-tooltip> </md-button> ";
// Exports
export default code;